// 기본 설정 상수
const $_TYPE = {
    UNDEF: 'undefined',
    FUNC: 'function',
    NULL: 'null',
}

const $_WC = {
    localGovName: process.env.VUE_APP_LOCAL_GOV_NAME,                   // 지자체 명
    localGovCode: process.env.VUE_APP_LOCAL_GOV_CODE,                   // 지차체 코드
    localGovLatitude: process.env.VUE_APP_LOCAL_GOV_LATITUDE,           // 위도
    localGovLongitude: process.env.VUE_APP_LOCAL_GOV_LONGITUDE,         // 경도
    cp: process.env.VUE_APP_CONTEXT_PATH,
    assets: process.env.VUE_APP_ASSETS_PATH,
    apiBaseURL: process.env.VUE_APP_APIBASEURL,
    chartBaseURL: process.env.VUE_APP_CHARTBASEURL,
    fileBaseURL: process.env.VUE_APP_FILEBASEURL,
    fileDownloadURL: process.env.VUE_APP_FILEDOWNLOAD_URL,
    speechBaseURL: process.env.VUE_APP_SPEECHBASEURL,
    geojsonPath: process.env.VUE_APP_GEOJSON_PATH,
    adGuCode: process.env.VUE_APP_AD_GU_CODE,                           // 구코드
    viewScale: Math.ceil(window.innerWidth / 1920),                 // 사용자 view scale
    responsiveScale: window.innerWidth <= 460 ? 1 : window.innerWidth <= 769 ? 2 : 3,
    markerScale: (window.innerWidth / 1920) <= 1 ? 1 : (window.innerWidth / 1920) / 2,
    THREE_MIN_INTERVAL: 1000 * 60 * 3,
    FIVE_MIN_INTERVAL: 1000 * 60 * 5,
    TEN_MIN_INTERVAL: 1000 * 60 * 10,
    FIFTEEN_MIN_INTERVAL: 1000 * 60 * 15,
    TEN_SEC_INTERVAL: 1000 * 10,
    FIVE_SEC_INTERVAL: 1000 * 5,
    SEVEN_SEC_INTERVAL: 1000 * 7,
    ONE_HOUR_INTERVAL: 1000 * 60 * 60,
    SEOUL_CENTER_LNGLAT: [126.97942, 37.582128],
    KOREA_CENTER_LNGLAT: [127.001503, 36.909522],
    CCTV_MEDIA_URL: 'http://localhost:30005/cctvPlayHls.html',
    RTSP_BASE_URL: 'rtsp://98.25.127.91:5554/vurix/',
    CCTV_API_URL: '/api.do',
    VUE_TEST_URL: 'http://apis.data.go.kr/B090041/openapi/service/SpcdeInfoService/',
    isMobile: window.innerWidth < 912 ? true: false,
    is4K: window.innerWidth > 2736 ? true: false,
    mainMenuSeq: 48,
    seoulmapApiKey: '7375517557616c6938355068556774',
    eventReg: /[`,，《》≪≫~!@#$%^&*()_|+\-=?;:'"<>\{\}\[\]\\\/ ]/gim,
};

// 자료 종류 번호
const $_DKD = {
    LOGO: 2,                // 로고
    SAFETY: 71,             // 재난안전
    SAFETY_HIST: 72,        // 재난안전 히스토리
    ACCIDENT: 161,          // 돌발
    ENV_SENSOR: 1015,	    // 환경센서
    RAINFALL: 1868,         // 강우량
    DONG_RAINFALL: 1997,    // 동강우량계
    WATER_LEVEL: 1869,      // 하천수위
    DISASTER_WATER_LEVEL: 1870,     // 하천수위_재난예경보시스템

    WATER_QUALITY: 400,     // 강남구 수질
    WATER_SGG_QUALITY: 1181,  // 서울시 수질 현황
    AIR_FORECAST: 42,       // 대기질 예보통보
    AIR_SGG: 47,            // 시군구 대기 정보
    SAFETY_SGG_CENTER: 1183,    // 소방시설 시군구
    MOSQUITO: 1996,         // 모기방역
    MEDIUM_MOSQ: 1999,      // 매개모기
    SHADE_CANOPY: 2001,     // 그늘막

    SAFETY_CENTER: 1204,    // 소방시설
    MEDICAL_FAC: 1029,      // 의료시설
    POLICE: 1201,           // 경찰서
    UTIC_CCTV: 1984,        // utic CCTV
    UTIC_CCTV_POPUP_URL: 2050,        // utic CCTV POPUP URL
    AIR_POLLUTION: 48,      // 대기오염 측정소 정보
    WATER_RESERVOIR: 401,   // 수질측정소
    BUILDING_ALARM: 1152,   // 건설알림이
    BUILDING_PERMIT: 1153,  // 건축허가

    POP_UMD_LIFE_LOCAL: 300,            // 읍면동 별 생활인구 - 내국인
    POP_UMD_LIFE_FOREIGNER_LONG: 301,   // 읍면동 별 생활인구 - 장기체류 외국인
    POP_UMD_LIFE_FOREIGNER_SHORT: 302,  // 읍면동 별 생활인구 - 단기체류 외국인
    POP_UMD_AGE: 305,                   // 읍면동 별 인구
    POP_UMD_LIFE_INPUT: 306,            // 읍면동 별 생활인구 - 대도시권
    POP_UMD_AGE_SINGLE: 308,            // 1인가구

    PARKING: 1012,                      // 민영주차장
    PARKING_PUBLIC: 1013,               // 공영주차장
    PARKING_LOCAL: 901,                 // 거주자우선 주차장
    PARKING_ILLEGAL: 905,               // 서울시 주차단속
    PARKING_LOCAL_ILLEGAL: 904,         // 거주자우선 단속
    ACCIDENT_HAZARD: 62, 				// 보행어린이사고다발지역
    SCHOOL_ACCIDENT_HAZARD: 63, 		// 스쿨존어린이사고다발지역
    SUBWAY_POP: 1160,					// 지하철 승하차 인원
    BUS_IN_POP: 1158,					// 버스 승차 인원
    BUS_OUT_POP: 1159,					// 버스 하차 인원
    DEV_BUILDING: 1860,                 // 주택건설지도
    ROUND_ROAD_POINT: 1638,             // 둘레길 지점정보

    ADDONG_TRDAR: 1308,                 // 상권 행정동개요
    ADDONG_POP_TRDAR: 1316,             // 상권 행정동인구
    SIDO_TRDAR: 1310,                   // 상권 시도개요
    POP_TRDAR: 1319,                    // 상권 상권인구
    TRDAR_TRDAR: 1311,                  // 상권 상권개요
    RANT_TRDAR: 1315,                   // 상권 임대시세

    ALLEY_GIS_TRDAR: 1301,              // 골목상권 GIS 정보
    DEVLOP_GIS_TRDAR: 1302,             // 발달상권 GIS 정보
    TRDIT_GIS_TRDAR: 1303,              // 전통시장상권 GIS 정보
    TURSM_GIS_TRDAR: 1304,              // 관광특구상권 GIS 정보

    GANGNAM_CLASS: 581,                 // 품격강남
    GANGNAM_CLASS_DETAIL: 580,          // 품격강남 상세

    BRIEFING: 1865,                     // 정책브리핑
    GU_NEWS: 1005,                      // 구청 뉴스
    VIDEO_NEWS: 1003,                   // 동영상 뉴스
    TODAY_PHOTO: 1006,                  // 오늘의포토

    READ: 1250,                         // 데이터로 분석한 구정 카테고리
    READ_DETAIL: 1251,                  // 데이터로 분석한 구정

    BIZ_LIST: 500,                      // 주요사업
    BIZ_HISTORY_LIST: 501,              // 주요사업 히스토리
    BIZ_DETAIL: 502,                    // 주요사업 상세
    BIZ_PROMISE_CATE: 504,              // 주요사업 공약 카테고리
    BIZ_SMART_CATE: 506,              // 주요사업 스마트 카테고리
    BIZ_TAB: 507,              // 주요사업 탭

    LIKE: 3,                            // 좋아요

    APT_STATE: 1864,                    // 아파트 경과 현황
    REBUILD_BIZ: 1865,                  // 재건축 추진
    REBUILD: 1864,                      // 재건축 추진
    REBUILD_DETAIL: 1851,               // 재건축 상세내역

    SEARCH_KEYWORD: 4,                  // 검색어
    REALTIME_SUMMARY: 35,               // 실시간 데이터 summary

    OPENAPI_GRID_DATA: 1252,            // 공공데이터 그리드
    OPENAPI_ERROR_REPORT: 2018,         // 공공데이터 오류 신고

    WELCOME: 5,                         // 웰컴보드
    WELCOME_CITIZEN: 15,                // 대민 웰컴보드(서버저장에서 db 저장으로 변경)
    COVID_CONFIRM: 75,                  // 코로나 확진자
    COVID_SEOUL_CONFIRM: 74,            // 서울시 코로나 확진자
    COVID_DAY_SEOUL_CONFIRM: 702,       // 서울시 일일 코로나 확진자
    COVID_STATUS_GANGNAM: 700,          // 강남구 코로나 현황
    COVID_STATUS_NATIONAL: 701,         // 전국 코로나 현황
    COVID_ISOLATION: 76,                // 코로나 격리건
    COVID_CHECKUP_LOC: 1981,            // 코로나 선별진료소 지역별 검사 현황
    COVID_GU_SUMMARY: 1992,             // 구별 합계

    REALTIME_CITY: 2015,                // 실시간도시데이터
    REALTIME_CITY_XML: 2025,            // 실시간도시데이터 XML
    CULTURAL_EVENT: 2019,                // 서울시 문화행사 정보(열광)
    INTRO_VIDEO: 6,                     // 대민 소개영상

    DISASTER_TXT: 2013,                 // 재난문자
    DISASTER_TEXT: 2036,                // 재난문자 - 재난안전데이터공유플랫폼


    GREEN_TREE: 1253,                   // 푸른도시 나무심기 - 디지털시민시장실
    GREEN_ROAD: 1254,                   // 푸른도시 녹음길 - 디지털시민시장실
    GREEN_DAN: 1255,                   // 푸른도시 단풍길 - 디지털시민시장실

    GREEN_ENERGY: 1258,                   // 동별 에너지 사용량 - 에너지정보

    // AIR_STATION : 2030,                   // 근접 측정소 목록(사용안함)
    AIR_STATION_VL: 50,                   // 측정소별 대기 측정값

    HOSPITAL: 2022,                       // 병‧의원 목록정보
    HOSPITAL_SUGI: 2034,                       // 병‧의원 목록정보 소아 야간 수기
    PHARMACY: 2024,                       // 약국 목록정보
    PHARMACY_SUGI: 2033,                       // 약국 목록정보
    APART_TRADE: 1111,                      // 아마트 매매 - 공공데이터 포털

    WORKNET_INCRUDE_INFO: 2021,                      // 워크넷 채용정보
    WORKNET_INCRUDE_TROT: 2023,                      // 워크넷 공채속보 및 정보
    SEOUL_WORK_INCRUDE_INFO: 2031,                      // 서울시 채용시험 정보
    GOV_WORK_INCRUDE: 2032,                      // 공공취업정보 목록조회
    SOG_WORKINCRUDE: 2035,                      // 채용공고 - 강남구청 홈페이지

    NEW_WELC: 97,                               // NEW 웰컴보드 - 대민
};

// 코드 그룹 상수 정의
const $_GCD = {
    PROMISE_CHANGE_ORDER: 311000,
    PROMISE_FIELD: 402010,
    SMART_FIELD : 404010,
    DATASRC_CATE : 'DATASRC_CATE',
    LFCNVNC_HP_CATE: 'LFCNVNC_HP_CATE',
};

// 코드 상수 정의
const $_CD = {
    INDICATOR_CATEGORY: '201000',   // 구정지표
    DATA_SEOUL_HJDCD: '000104',     // 열광 행정동
    FACILITY_CATEGORY: '403000',    // 시설코드
    DEV_BUILDING: '503010',         // 주택건설사업 지구
    TOP_DEPT_CODE: 32200000000,     // 강남구청
    RE_BUILDING: '503021',
    BUILDING_BIZ: '503030',         //주택건설사업
    SAFETY_CATE_CODE: '200001',     //재난종류코드
    CLAZZ_CATEGORY: '502010', // 품격강남 분류
};

const $_ADM = {
    ADDONG_CENTER_MAP: {
        1168051000: {lat: 37.526010, lng: 127.020781, dongNm: '신사동'},      //신사동
        1168052100: {lat: 37.511570, lng: 127.027461, dongNm: '논현1동'},      //논현1동
        1168053100: {lat: 37.514970, lng: 127.036461, dongNm: '논현2동'},      //논현2동
        1168054500: {lat: 37.529642, lng: 127.034713, dongNm: '압구정동'},      //압구정동
        1168056500: {lat: 37.524083, lng: 127.050900, dongNm: '청담동'},      //청담동
        1168058000: {lat: 37.514995, lng: 127.061524, dongNm: '삼성1동'},      //삼성1동
        1168059000: {lat: 37.511295, lng: 127.049624, dongNm: '삼성2동'},      //삼성2동
        1168060000: {lat: 37.493140, lng: 127.059976, dongNm: '대치1동'},      //대치1동
        1168061000: {lat: 37.500840, lng: 127.066076, dongNm: '대치2동'},      //대치2동
        1168063000: {lat: 37.501140, lng: 127.055676, dongNm: '대치4동'},      //대치4동
        1168064000: {lat: 37.500484, lng: 127.036357, dongNm: '역삼1동'},      //역삼1동
        1168065000: {lat: 37.498484, lng: 127.045957, dongNm: '역삼2동'},      //역삼2동
        1168065500: {lat: 37.488869, lng: 127.041875, dongNm: '도곡1동'},      //도곡1동
        1168065600: {lat: 37.488169, lng: 127.050075, dongNm: '도곡2동'},      //도곡2동
        1168066000: {lat: 37.477089, lng: 127.063866, dongNm: '개포1동'},      //개포1동
        1168067000: {lat: 37.484348, lng: 127.069463, dongNm: '개포2동'},      //개포2동
        1168067500: {lat: 37.496089, lng: 127.079466, dongNm: '개포3동'},      //개포3동
        1168069000: {lat: 37.475289, lng: 127.054466, dongNm: '개포4동'},      //개포4동
        1168070000: {lat: 37.470360, lng: 127.104600, dongNm: '세곡동'},      //세곡동
        1168072000: {lat: 37.482410, lng: 127.085010, dongNm: '일원본동'},      //일원본동
        1168073000: {lat: 37.493348, lng: 127.089963, dongNm: '일원1동'},      //일원1동
        // 1168074000: {lat: 37.496089, lng: 127.079466, dongNm: '일원2동'},      //일원2동
        1168075000: {lat: 37.486348, lng: 127.100463, dongNm: '수서동'},      //수서동
    },
    ADDONG_NM_MAP: {
        '신사동': 1168051000,      //신사동
        '논현1동': 1168052100,      //논현1동
        '논현2동': 1168053100,      //논현2동
        '압구정동': 1168054500,      //압구정동
        '청담동': 1168056500,      //청담동
        '삼성1동': 1168058000,      //삼성1동
        '삼성2동': 1168059000,      //삼성2동
        '대치1동': 1168060000,      //대치1동
        '대치2동': 1168061000,      //대치2동
        '대치4동': 1168063000,      //대치4동
        '역삼1동': 1168064000,      //역삼1동
        '역삼2동': 1168065000,      //역삼2동
        '도곡1동': 1168065500,      //도곡1동
        '도곡2동': 1168065600,      //도곡2동
        '개포1동': 1168066000,      //개포1동
        '개포2동': 1168067000,      //개포2동
        '개포3동': 1168067500,      //개포3동
        '개포4동': 1168069000,      //개포4동
        '세곡동': 1168070000,      //세곡동
        '일원본동': 1168072000,      //일원본동
        '일원1동': 1168073000,      //일원1동
        // '일원2동': 1168074000,      //일원2동
        '수서동': 1168075000,      //수서동
    },
    LEGDONG_CENTER_MAP: {
        1168010100: {lat: 37.498484, lng: 127.039957, dongNm: '역삼동'},  //역삼동
        1168010300: {lat: 37.477089, lng: 127.063866, dongNm: '개포동'},  //개포동
        1168010400: {lat: 37.524083, lng: 127.050900, dongNm: '청담동'},  //청담동
        1168010500: {lat: 37.512295, lng: 127.055224, dongNm: '삼성동'},  //삼성동
        1168010600: {lat: 37.498140, lng: 127.061676, dongNm: '대치동'},  //대치동
        1168010700: {lat: 37.526010, lng: 127.020781, dongNm: '신사동'},  //신사동
        1168010800: {lat: 37.511570, lng: 127.031461, dongNm: '논현동'},  //논현동
        1168011000: {lat: 37.529642, lng: 127.034713, dongNm: '압구정동'},  //압구정동
        1168011400: {lat: 37.488348, lng: 127.083463, dongNm: '일원동'},  //일원동
        1168011500: {lat: 37.486348, lng: 127.100463, dongNm: '수서동'},  //수서동
        1168011800: {lat: 37.487869, lng: 127.046475, dongNm: '도곡동'},  //도곡동
        1168011300: {lat: 37.473108, lng: 127.118154, dongNm: '율현동'},  //율현동
        1168011100: {lat: 37.470360, lng: 127.104600, dongNm: '세곡동'},  //세곡동
        1168011200: {lat: 37.473279, lng: 127.089058, dongNm: '자곡동'},  //자곡동
    },
    LEGDONG_NM_MAP: {
        '역삼동' : 1168010100,  //역삼동
        '개포동' : 1168010300,  //개포동
        '청담동' : 1168010400,  //청담동
        '삼성동' : 1168010500,  //삼성동
        '대치동' : 1168010600,  //대치동
        '신사동' : 1168010700,  //신사동
        '논현동' : 1168010800,  //논현동
        '압구정동' : 1168011000,  //압구정동
        '세곡동': 1168011100,  //세곡동
        '일원동': 1168011400,  //일원동
        '수서동': 1168011500,  //수서동
        '도곡동': 1168011800,  //도곡동
        '율현동': 1168011300,  //율현동
        '자곡동': 1168011200,  //자곡동
    },
    RAINFALL_CENTER_MAP: {
        '강남구청':{lat:37.517708019897626 , lng:127.04799628419423},
        '세곡동':{lat:37.47151283292517 , lng:127.10663587729404},
        '개포2동':{lat:37.489225401002884 , lng:127.06504485113437},
        '역삼1동': {lat: 37.49535648, lng:127.03328440},
    },
    WATER_LEVEL_LOC_MAP: {
        '101' : {lat: 37.421848, lng: 127.116786}, //여수대교
        '102' : {lat: 37.468910, lng: 127.122524}, //대곡교
        '103' : {lat: 37.502159, lng: 127.070401}, //탄천2교
        '001008' : {lat: 37.49361584451989, lng: 127.07259795188943}, //영동6교
        '001001' : {lat: 37.46235, lng: 127.1074}, //세곡2교
        '001006' : {lat: 37.48477, lng: 127.0517}, //영동3교
    },
    GU_CENTER_MAP: {
        '성동구': {lat: 37.54824, lng: 127.043114},
        '종로구': {lat: 37.592128000000002, lng: 126.97942},
        '중구': {lat: 37.562335000000002, lng: 126.997985},
        '용산구': {lat: 37.528582, lng: 126.981987},
        '성북구': {lat: 37.602916999999998, lng: 127.01969699999999},
        '강북구': {lat: 37.640709999999999, lng: 127.013272},
        '도봉구': {lat: 37.666330000000002, lng: 127.034471},
        '노원구': {lat: 37.649734000000002, lng: 127.077134},
        '은평구': {lat: 37.616430999999999, lng: 126.929119},
        '서대문구': {lat: 37.574997000000003, lng: 126.94115499999999},
        '마포구': {lat: 37.556708, lng: 126.910326},
        '양천구': {lat: 37.521940000000001, lng: 126.85752599999999},
        '강서구': {lat: 37.558439999999997, lng: 126.824859},
        '구로구': {lat: 37.491580999999996, lng: 126.858351},
        '동작구': {lat: 37.503074999999998, lng: 126.953734},
        '관악구': {lat: 37.464570000000002, lng: 126.947435},
        '금천구': {lat: 37.457774999999998, lng: 126.902894},
        '영등포구': {lat: 37.519739000000001, lng: 126.91230299999999},
        '광진구': {lat: 37.543059, lng: 127.088351},
        '동대문구': {lat: 37.579132000000001, lng: 127.057221},
        '중랑구': {lat: 37.595193999999999, lng: 127.095157},
        '서초구': {lat: 37.470739999999999, lng: 127.03324499999999},
        '강남구': {lat: 37.493712000000002, lng: 127.06533399999999},
        '송파구': {lat: 37.502167999999998, lng: 127.118003},
        '강동구': {lat: 37.552522000000001, lng: 127.149107},
    },

    // 근접측정소 맵핑(측정소코드와 맵핑)
    ADDONG_NM_STATION_MAP: {
        '신사동': 111263,      //신사동
        '논현1동': 111263,      //논현1동
        '논현2동': 111263,      //논현2동
        '압구정동': 111143,      //압구정동
        '청담동': 111261,      //청담동
        '삼성1동': 111261,      //삼성1동
        '삼성2동': 111261,      //삼성2동
        '대치1동': 111273,      //대치1동
        '대치2동': 111273,      //대치2동
        '대치4동': 111273,      //대치4동
        '역삼1동': 111264,      //역삼1동
        '역삼2동': 111264,      //역삼2동
        '도곡1동': 111264,      //도곡1동
        '도곡2동': 111264,      //도곡2동
        '개포1동': 111264,      //개포1동
        '개포2동': 111264,      //개포2동
        '개포3동': 111264,      //개포3동
        '개포4동': 111264,      //개포4동
        '세곡동': 131126,      //세곡동
        '일원본동': 111273,      //일원본동
        '일원1동': 111273,      //일원1동
        // '일원2동': 1168074000,      //일원2동
        '수서동': 111273,      //수서동
    },

    // 2번째 근접측정소 맵핑
    ADDONG_NM_SEC_STATION_MAP: {
        '신사동': 111261,      //신사동
        '논현1동': 111261,      //논현1동
        '논현2동': 111261,      //논현2동
        '압구정동': 111263,      //압구정동
        '청담동': 111143,      //청담동
        '삼성1동': 111273,      //삼성1동
        '삼성2동': 111273,      //삼성2동
        '대치1동': 111261,      //대치1동
        '대치2동': 111261,      //대치2동
        '대치4동': 111261,      //대치4동
        '역삼1동': 111261,      //강남구
        '역삼2동': 111261,      //강남구
        '도곡1동': 111261,      //강남구
        '도곡2동': 111261,      //강남구
        '개포1동': 111273,      //송파구
        '개포2동': 111273,      //송파구
        '개포3동': 111273,      //송파구
        '개포4동': 111273,      //송파구
        '세곡동': 111273,      //세곡동
        '일원본동': 111264,      //일원본동
        '일원1동': 111264,      //일원1동
        '수서동': 131126,      //수서동
    },
};

// 부서 코드
const $_DEPT = {
    // 구청장
    firstHead: '32400600000',
    // 부구청장
    secondHead: '32400610000',
    // 도시관리 국장
    cityDeptHead: '32400760000',
    // 도시 계획과 하위 팀
    cityPlanDept: '32401590000',
}

// 네이버 지도 관련 상수
const $_NM = {
    TILE_SIZE: 256,
    TILE_SIZE_SCALE: $_WC.viewScale * 1,   // 네이버 지도 타일 사이즈 스케일

    ZOOM_LEVEL: $_WC.responsiveScale === 1 ? 12 : 13,   // 네이버 지도 줌 레벨
    MAX_ZOOM: 20,
    MIN_ZOOM: 1,
    MARKER_W: 28,                   // 마커 width
    MARKER_H: 35,                   // 마커 height
    MARKER2_W: 25,                   // 마커 width
    MARKER2_H: 25,                   // 마커 height
}

export {$_TYPE, $_WC, $_DKD, $_GCD, $_CD, $_ADM, $_DEPT, $_NM}
